import React from 'react'
import { X } from 'lucide-react'
import Loader from '../Progress/Loader'

const FileUpload = (props) => {
  const {
    id,
    file,
    uploadFile,
    uploadProgress,
    showProgress,
    disabled,
    showImage,
    removeFile,
    showRemoveOption,
    acceptedFileTypes = 'image/jpeg,image/png,image/jpg',
  } = props

  const closeButton = (
    <button
      type="button"
      className="edvi-file-upload__remove"
      aria-label="close"
      onClick={() => removeFile()}
    >
      <X size={14} strokeWidth={2.25} />
    </button>
  )

  return (
    <>
      <label htmlFor={id}>
        {!showProgress && !disabled && !file ? (
          <div className="edvi-file-upload" role="button" tabIndex={0}>
            +
          </div>
        ) : null}
      </label>

      {file && showImage ? (
        <div className="edvi-file-upload__image" role="button" tabIndex={0}>
          {showRemoveOption ? (
            <div className="edvi-file-upload__remove-row">
              {removeFile ? closeButton : null}
            </div>
          ) : null}
          <div className="edvi-file-upload__preview">
            {disabled ? (
              <img height={60} width={60} src={file} alt="id card" />
            ) : (
              <a href={file} target="_blank" rel="noopener noreferrer">
                <img height={60} width={60} src={file} alt="id card" />
              </a>
            )}
          </div>
        </div>
      ) : null}

      {showProgress && !file ? (
        <div className="edvi-file-upload edvi-file-upload--progress" role="button" tabIndex={0}>
          +
        </div>
      ) : null}
      {showProgress ? <Loader value={uploadProgress} /> : null}

      {disabled && !file ? (
        <div className="edvi-file-upload edvi-file-upload--disabled" role="button" tabIndex={0}>
          +
        </div>
      ) : null}

      {file && !showImage ? (
        <div className="edvi-file-upload edvi-file-upload--file" role="button" tabIndex={0}>
          <p className="edvi-file-upload__name">{file.name}</p>
        </div>
      ) : null}

      <input
        id={id}
        className="edvi-file-upload__input"
        onChange={(e) => uploadFile(e.target.files[0])}
        type="file"
        accept={acceptedFileTypes}
        hidden
        disabled={showProgress || disabled}
      />
    </>
  )
}

export default FileUpload
